import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { tituloDeRuta } from './utils/titulo'
import Layout from './components/Layout'
import ErrorBoundary from './components/ErrorBoundary'
import LoginPage from './pages/LoginPage'
import { inicioSegunPantalla } from './utils/inicio'
import SeguridadPage from './pages/SeguridadPage'
import DashboardPage from './pages/DashboardPage'
import ZonasPage from './pages/ZonasPage'
import FleterosPage from './pages/FleterosPage'
import ArticulosPage from './pages/ArticulosPage'
import ArticulosPlanillaPage from './pages/ArticulosPlanillaPage'
import ArticuloFichaPage from './pages/ArticuloFichaPage'
import ClientesPage from './pages/ClientesPage'
import MediosPagoPage from './pages/MediosPagoPage'
import MotivosNoEntregaPage from './pages/MotivosNoEntregaPage'
import UsuariosPage from './pages/UsuariosPage'
import RolesPage from './pages/RolesPage'
import TablasPage from './pages/TablasPage'
import AgentesMemoriaPage from './pages/AgentesMemoriaPage'
import AutomataPage from './pages/AutomataPage'
import CorreosPage from './pages/CorreosPage'
import CazadorPage from './pages/CazadorPage'
import NotasVentaPage from './pages/NotasVentaPage'
import NotaVentaFormPage from './pages/NotaVentaFormPage'
import NotaVentaFormV2Page from './pages/NotaVentaFormV2Page'
import NotaVentaDetallePage from './pages/NotaVentaDetallePage'
import PresupuestosPage from './pages/PresupuestosPage'
import CarritosAbandonadosPage from './pages/CarritosAbandonadosPage'
import WhatsAppCobrosPage from './pages/WhatsAppCobrosPage'
import CuentasWebPage from './pages/CuentasWebPage'
import PropuestasVentaPage from './pages/PropuestasVentaPage'
import PropuestaVentaFormPage from './pages/PropuestaVentaFormPage'
import WineClubComposicionPage from './pages/WineClubComposicionPage'
import PresupuestoFormPage from './pages/PresupuestoFormPage'
import PresupuestoDetallePage from './pages/PresupuestoDetallePage'
import GiftCardsPage from './pages/GiftCardsPage'
import GiftCardsHeredadasPage from './pages/GiftCardsHeredadasPage'
import GiftCardFormPage from './pages/GiftCardFormPage'
import GiftCardDetallePage from './pages/GiftCardDetallePage'
import ListasPreciosPage from './pages/ListasPreciosPage'
import PromocionesPage from './pages/PromocionesPage'
import FotosPendientesPage from './pages/FotosPendientesPage'
import StockMasEsperadosPage from './pages/StockMasEsperadosPage'
import ConsultasStockPage from './pages/ConsultasStockPage'
import InventarioPage from './pages/InventarioPage'
import DepositoConsultaStockPage from './pages/DepositoConsultaStockPage'
import MovilConsultasStock from './pages/movil/MovilConsultasStock'
import MovilConsultaStock from './pages/movil/MovilConsultaStock'
import ExperienciasWebPage from './pages/ExperienciasWebPage'
import TraduccionesWebPage from './pages/TraduccionesWebPage'
import FiltrosTiendaPage from './pages/FiltrosTiendaPage'
import InformesEventoPage from './pages/InformesEventoPage'
import InformeEventoFormPage from './pages/InformeEventoFormPage'
import InformeEventoNuevoPage from './pages/InformeEventoNuevoPage'
import ExperienciaWebFormPage from './pages/ExperienciaWebFormPage'
import PagosPage from './pages/PagosPage'
import PagoFormPage from './pages/PagoFormPage'
import PagoDetallePage from './pages/PagoDetallePage'
import RemitosPage from './pages/RemitosPage'
import RemitoFormPage from './pages/RemitoFormPage'
import RemitoDetallePage from './pages/RemitoDetallePage'
import CasosPage from './pages/CasosPage'
import CasoDevolucionPage from './pages/CasoDevolucionPage'
import PlanillaObsequiadosPage from './pages/PlanillaObsequiadosPage'
import NotaEnvioDetallePage from './pages/NotaEnvioDetallePage'
import AsignacionPage from './pages/AsignacionPage'
import SalidaFormPage from './pages/SalidaFormPage'
import SalidaDetallePage from './pages/SalidaDetallePage'
import LogisticaNeDetallePage from './pages/LogisticaNeDetallePage'
import DistribucionPage from './pages/DistribucionPage'
import RetirosPage from './pages/RetirosPage'
import ResenasPage from './pages/ResenasPage'
import WineClubSociosPage from './pages/WineClubSociosPage'
import RetirosListaPage from './pages/RetirosListaPage'
import HistorialPage from './pages/HistorialPage'
import FleteroSalidaPage from './pages/FleteroSalidaPage'
import SeguimientoClientePage from './pages/SeguimientoClientePage'
import EncuestaCompraPage from './pages/EncuestaCompraPage'
import EncuestaEventoPage from './pages/EncuestaEventoPage'
import ResultadosEncuestaEventoPage from './pages/ResultadosEncuestaEventoPage'
import PortalClientePage from './pages/PortalClientePage'
import PortalClientesAdminPage from './pages/PortalClientesAdminPage'
import HistoriaClientePage from './pages/HistoriaClientePage'
import DeudoresPage from './pages/DeudoresPage'
import ListaNegraPage from './pages/ListaNegraPage'
import ResenasProductosPage from './pages/ResenasProductosPage'
import SommelierConsultasPage from './pages/SommelierConsultasPage'
import MktProximaSeleccionPage from './pages/MktProximaSeleccionPage'
import MktSegundaCompraPage from './pages/MktSegundaCompraPage'
import MktRecompraPage from './pages/MktRecompraPage'
import MktRegalosEmpresarialesPage from './pages/MktRegalosEmpresarialesPage'
import MktNewsletterExperienciasPage from './pages/MktNewsletterExperienciasPage'
import ValoresPage from './pages/ValoresPage'
import LogActividadPage from './pages/LogActividadPage'
import AsistenteConversacionesPage from './pages/AsistenteConversacionesPage'
import SugerenciasPage from './pages/SugerenciasPage'
import InformesPage from './pages/InformesPage'
import BiTableroPage from './pages/BiTableroPage'
import BiVentasPage from './pages/BiVentasPage'
import BiGastosPage from './pages/BiGastosPage'
import BiCuboPage from './pages/BiCuboPage'
import BiCuboVentasPage from './pages/BiCuboVentasPage'
import BiReportesPage from './pages/BiReportesPage'
import MovilReportes from './pages/movil/MovilReportes'
import BiAppLayout from './pages/biapp/BiAppLayout'
import BiAppHome from './pages/biapp/BiAppHome'
import BiAppVentas from './pages/biapp/BiAppVentas'
import MovilLayout from './pages/movil/MovilLayout'
import MovilHome from './pages/movil/MovilHome'
import MovilVentas from './pages/movil/MovilVentas'
import MovilVentaDetalle from './pages/movil/MovilVentaDetalle'
import MovilNvNueva from './pages/movil/MovilNvNueva'
import MovilProcesarNv from './pages/movil/MovilProcesarNv'
import MovilClientes from './pages/movil/MovilClientes'
import MovilClienteHistoria, { MovilHistoriaBuscar } from './pages/movil/MovilClienteHistoria'
import MovilDeudores from './pages/movil/MovilDeudores'
import MovilLogistica from './pages/movil/MovilLogistica'
import MovilRemitoDetalle from './pages/movil/MovilRemitoDetalle'
import MovilNeDetalle from './pages/movil/MovilNeDetalle'
import MovilReparto from './pages/movil/MovilReparto'
import MovilPagoDetalle from './pages/movil/MovilPagoDetalle'
import MovilResenas from './pages/movil/MovilResenas'
import MovilWineClub from './pages/movil/MovilWineClub'
import MovilExperienciaNueva from './pages/movil/MovilExperienciaNueva'
import MovilExperiencias from './pages/movil/MovilExperiencias'
import MovilExperienciaInvitados from './pages/movil/MovilExperienciaInvitados'
import MovilTablero from './pages/movil/MovilTablero'
import MovilSalidaDetalle from './pages/movil/MovilSalidaDetalle'
import MktCampanasPage from './pages/MktCampanasPage'
import MktCampanaFormPage from './pages/MktCampanaFormPage'
import MktCampanaDetallePage from './pages/MktCampanaDetallePage'
import MktListasPage from './pages/MktListasPage'
import MktAutomationsPage from './pages/MktAutomationsPage'
import MktPlantillasPage from './pages/MktPlantillasPage'
import MktContactosPage from './pages/MktContactosPage'
import WhatsAppPage from './pages/WhatsAppPage'
import WhatsAppConfigPage from './pages/WhatsAppConfigPage'
import MagentoPage from './pages/MagentoPage'
import MercadolibrePage from './pages/MercadolibrePage'
import MovilPreciosMl from './pages/movil/MovilPreciosMl'
import MovilFotos from './pages/movil/MovilFotos'
import MovilConteo from './pages/movil/MovilConteo'
import PreseaPage from './pages/PreseaPage'
import PreseaCola from './pages/presea/PreseaCola'
import PreseaMaestros from './pages/presea/PreseaMaestros'
import MenuPermisosPage from './pages/MenuPermisosPage'
import FacturasPage from './pages/FacturasPage'
import LogisticaRemitosPage from './pages/LogisticaRemitosPage'
import CajaPagosPage from './pages/CajaPagosPage'
import CajaCobranzasPage from './pages/CajaCobranzasPage'
import CajaMinutasPage from './pages/CajaMinutasPage'
import ConciliacionTarjetasPage from './pages/ConciliacionTarjetasPage'
import PagosProveedoresPage from './pages/PagosProveedoresPage'
import PagoProveedorDetallePage from './pages/PagoProveedorDetallePage'
import BancosPreseaPage from './pages/BancosPreseaPage'
import CuentasContablesPage from './pages/CuentasContablesPage'
import SueAdicPage from './pages/SueAdicPage'
import SueAdicEstadisticasPage from './pages/SueAdicEstadisticasPage'
import AgentesPage from './pages/AgentesPage'
import PagadoresPage from './pages/PagadoresPage'
import BonusPage from './pages/BonusPage'
import BonusAcuerdoPage from './pages/BonusAcuerdoPage'
import Emp900FacturasPage from './pages/emp900/Emp900FacturasPage'
import Emp900RecibosPage from './pages/emp900/Emp900RecibosPage'
import Emp900RemitosPage from './pages/emp900/Emp900RemitosPage'
import Emp900ImprimirPage from './pages/emp900/Emp900ImprimirPage'
import Emp900ComprasPage from './pages/emp900/Emp900ComprasPage'
import Emp900CuentaPage from './pages/emp900/Emp900CuentaPage'
import Emp900StockPage from './pages/emp900/Emp900StockPage'
import PedidosConsultaPage from './pages/compras/PedidosConsultaPage'
import PedidoOperacionPage from './pages/compras/PedidoOperacionPage'
import NotaPedidoFormPage from './pages/compras/NotaPedidoFormPage'
import NotaPedidoDetallePage from './pages/compras/NotaPedidoDetallePage'
import ProcesosEntrevistasPage from './pages/ProcesosEntrevistasPage'
import ProcesosEntrevistaDetallePage from './pages/ProcesosEntrevistaDetallePage'
import EntrevistaPublicaPage from './pages/EntrevistaPublicaPage'

function PrivateRoute({ children }) {
  const { user, realUser } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  // El rol REAL exige el segundo factor y no está activado: la app entera es
  // SOLO la pantalla de Seguridad hasta activarlo (el backend cierra todo lo
  // demás con 403 totp_requerido; /me refresca los flags al activar).
  if (realUser?.tfa_obligatorio && !realUser?.tfa_habilitado) return <SeguridadPage bloqueada />
  return children
}

// Setea el título de la pestaña "LGR - <sección>" según la ruta activa.
function useTituloPestana() {
  const { pathname } = useLocation()
  useEffect(() => { document.title = tituloDeRuta(pathname) }, [pathname])
}

function AppRoutes() {
  const { user } = useAuth()
  useTituloPestana()

  return (
    // La red de seguridad va ADENTRO del router: así el error queda acotado a
    // la pantalla y el usuario conserva la sesión y puede navegar a otra.
    <ErrorBoundary>
    <Routes>
      <Route path="/login" element={user ? <Navigate to={inicioSegunPantalla()} replace /> : <LoginPage />} />
      <Route path="/" element={<Navigate to={inicioSegunPantalla()} replace />} />
      {/* Ruta pública para el fletero — sin sidebar */}
      <Route path="/fletero/salida/:token" element={<FleteroSalidaPage />} />
      {/* Ruta pública para el cliente — seguimiento de su pedido */}
      <Route path="/seguimiento/:token" element={<SeguimientoClientePage />} />
      <Route path="/encuesta/:token" element={<EncuestaCompraPage />} />
      <Route path="/encuesta-evento/:token" element={<EncuestaEventoPage />} />
      {/* Sin token (link roto, test de Brevo sin atributo): página PÚBLICA de
          error de la encuesta — jamás caer al shell interno de LGR. */}
      <Route path="/encuesta" element={<EncuestaCompraPage />} />
      <Route path="/encuesta-evento" element={<EncuestaEventoPage />} />
      {/* Impresión plana de un comprobante de la 900 — sin sidebar, con sesión */}
      <Route path="/emp900/imprimir/:id" element={<PrivateRoute><Emp900ImprimirPage /></PrivateRoute>} />
      {/* Lista para separar (retiros por sucursal): se imprime, va sin el layout */}
      <Route path="/logistica/retiros/lista" element={<PrivateRoute><RetirosListaPage /></PrivateRoute>} />
      <Route path="/resultados-encuesta-evento/:token" element={<ResultadosEncuestaEventoPage />} />
      {/* Ruta pública para el cliente — portal "mi cuenta" (magic link) */}
      <Route path="/portal" element={<PortalClientePage />} />
      <Route path="/portal/:token" element={<PortalClientePage />} />
      {/* Ruta pública para el empleado — entrevista de relevamiento de procesos */}
      <Route path="/entrevista/:token" element={<EntrevistaPublicaPage />} />
      {/* Link del Telegram de depósito: con sesión pasa a /m, sin sesión responde por token */}
      <Route path="/deposito/consulta-stock/:token" element={<DepositoConsultaStockPage />} />
      {/* Versión móvil de LGR — ventas (crear/procesar), clientes, logística y reparto */}
      <Route
        path="/m/*"
        element={
          <PrivateRoute>
            <MovilLayout>
              <Routes>
                <Route path="/" element={<MovilHome />} />
                <Route path="/ventas" element={<MovilVentas />} />
                <Route path="/ventas/nueva" element={<MovilNvNueva />} />
                <Route path="/ventas/:id" element={<MovilVentaDetalle />} />
                <Route path="/ventas/:id/procesar" element={<MovilProcesarNv />} />
                <Route path="/clientes" element={<MovilClientes />} />
                <Route path="/precios-ml" element={<MovilPreciosMl />} />
                <Route path="/reportes" element={<MovilReportes />} />
                <Route path="/reportes/:clave" element={<MovilReportes />} />
                <Route path="/fotos" element={<MovilFotos />} />
                <Route path="/conteo" element={<MovilConteo />} />
                <Route path="/consultas-stock" element={<MovilConsultasStock />} />
                <Route path="/consultas-stock/:id" element={<MovilConsultaStock />} />
                <Route path="/clientes/:id/historia" element={<MovilClienteHistoria />} />
                <Route path="/historia" element={<MovilHistoriaBuscar />} />
                <Route path="/deudores" element={<MovilDeudores />} />
                <Route path="/logistica" element={<MovilLogistica />} />
                <Route path="/logistica/remito/:id" element={<MovilRemitoDetalle />} />
                <Route path="/logistica/ne/:id" element={<MovilNeDetalle />} />
                <Route path="/reparto" element={<MovilReparto />} />
                <Route path="/pagos/:id" element={<MovilPagoDetalle />} />
                <Route path="/resenas" element={<MovilResenas />} />
                <Route path="/wine-club" element={<MovilWineClub />} />
                <Route path="/experiencias" element={<MovilExperiencias />} />
                <Route path="/experiencias/nueva" element={<MovilExperienciaNueva />} />
                <Route path="/experiencias/:id" element={<MovilExperienciaInvitados />} />
                <Route path="/tablero" element={<MovilTablero />} />
                <Route path="/reparto/:id" element={<MovilSalidaDetalle />} />
                {/* WhatsApp en el celular: la misma bandeja del escritorio, en una columna, dentro del layout móvil */}
                <Route path="/whatsapp" element={<WhatsAppPage enMovil />} />
                <Route path="/whatsapp/:id" element={<WhatsAppPage enMovil />} />
              </Routes>
            </MovilLayout>
          </PrivateRoute>
        }
      />
      {/* App de BI — mobile-first, autenticada, layout propio (sin menú operativo) */}
      <Route
        path="/panel/*"
        element={
          <PrivateRoute>
            <BiAppLayout>
              <Routes>
                <Route path="/" element={<BiAppHome />} />
                <Route path="/ventas" element={<BiAppVentas />} />
              </Routes>
            </BiAppLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Layout>
              <Routes>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/seguridad" element={<SeguridadPage />} />
                <Route path="/zonas" element={<ZonasPage />} />
                <Route path="/fleteros" element={<FleterosPage />} />
                <Route path="/articulos" element={<ArticulosPage />} />
                <Route path="/articulos/planilla" element={<ArticulosPlanillaPage />} />
                <Route path="/articulos/nuevo" element={<ArticuloFichaPage />} />
                <Route path="/articulos/:id" element={<ArticuloFichaPage />} />
                <Route path="/clientes" element={<ClientesPage />} />
                <Route path="/clientes/historia" element={<HistoriaClientePage />} />
                <Route path="/clientes/deudores" element={<DeudoresPage />} />
                <Route path="/clientes/lista-negra" element={<ListaNegraPage />} />
                <Route path="/clientes/portal" element={<PortalClientesAdminPage />} />
                <Route path="/medios-pago" element={<MediosPagoPage />} />
                <Route path="/motivos-no-entrega" element={<MotivosNoEntregaPage />} />
                <Route path="/usuarios" element={<UsuariosPage />} />
                <Route path="/configuracion/roles" element={<RolesPage />} />
                <Route path="/sistema/tablas" element={<TablasPage />} />
                <Route path="/sistema/agentes-memoria" element={<AgentesMemoriaPage />} />
                <Route path="/configuracion/automata" element={<AutomataPage />} />
                <Route path="/configuracion/correos" element={<CorreosPage />} />
                <Route path="/configuracion/cazador" element={<CazadorPage />} />
                <Route path="/notas-venta" element={<NotasVentaPage />} />
                <Route path="/notas-venta/nueva" element={<NotaVentaFormV2Page />} />
                <Route path="/notas-venta/nueva-v2" element={<NotaVentaFormV2Page />} />  {/* alias del período de prueba */}
                <Route path="/notas-venta/:id" element={<NotaVentaDetallePage />} />
                <Route path="/notas-venta/:id/editar" element={<NotaVentaFormPage />} />
                <Route path="/carritos-abandonados" element={<CarritosAbandonadosPage />} />
                <Route path="/carritos-abandonados/whatsapp" element={<WhatsAppCobrosPage />} />
                <Route path="/presupuestos" element={<PresupuestosPage />} />
                <Route path="/wine-club/composicion" element={<WineClubComposicionPage />} />
                <Route path="/presupuestos/nuevo" element={<PresupuestoFormPage />} />
                <Route path="/presupuestos/:id" element={<PresupuestoDetallePage />} />
                <Route path="/presupuestos/:id/editar" element={<PresupuestoFormPage />} />
                <Route path="/propuestas-venta" element={<PropuestasVentaPage />} />
                <Route path="/propuestas-venta/nueva" element={<PropuestaVentaFormPage />} />
                <Route path="/propuestas-venta/:id" element={<PropuestaVentaFormPage />} />
                <Route path="/gift-cards" element={<GiftCardsPage />} />
                <Route path="/gift-cards/nueva" element={<GiftCardFormPage />} />
                <Route path="/gift-cards/heredadas" element={<GiftCardsHeredadasPage />} />
                <Route path="/gift-cards/:id" element={<GiftCardDetallePage />} />
                <Route path="/listas-precios" element={<ListasPreciosPage />} />
                <Route path="/promociones" element={<PromocionesPage />} />
                <Route path="/stock/mas-esperados" element={<StockMasEsperadosPage />} />
                <Route path="/stock/consultas-deposito" element={<ConsultasStockPage />} />
                <Route path="/stock/inventario" element={<InventarioPage />} />
                <Route path="/stock/fotos-pendientes" element={<FotosPendientesPage />} />
                {/* Experiencias de la tienda web (cenas, eventos, viajes) */}
                <Route path="/web/experiencias" element={<ExperienciasWebPage />} />
                <Route path="/web/traducciones" element={<TraduccionesWebPage />} />
                <Route path="/web/filtros" element={<FiltrosTiendaPage />} />
                <Route path="/web/experiencias/nueva" element={<ExperienciaWebFormPage />} />
                <Route path="/web/experiencias/:id" element={<ExperienciaWebFormPage />} />
                <Route path="/eventos/informes" element={<InformesEventoPage />} />
                <Route path="/eventos/informes/nuevo" element={<InformeEventoNuevoPage />} />
                <Route path="/eventos/informes/:id" element={<InformeEventoFormPage />} />
                <Route path="/facturas" element={<FacturasPage />} />
                <Route path="/recibos" element={<PagosPage />} />
                <Route path="/pagos" element={<PagosPage />} />
                <Route path="/pagos/nuevo" element={<PagoFormPage />} />
                <Route path="/pagos/:id" element={<PagoDetallePage />} />
                <Route path="/pagos/:id/editar" element={<PagoFormPage />} />
                <Route path="/finanzas/pagos" element={<CajaPagosPage />} />
                <Route path="/finanzas/cobranzas" element={<CajaCobranzasPage />} />
                <Route path="/finanzas/minutas" element={<CajaMinutasPage />} />
                <Route path="/finanzas/conciliacion-tarjetas" element={<ConciliacionTarjetasPage />} />
                <Route path="/finanzas/pagos-proveedores" element={<PagosProveedoresPage />} />
                <Route path="/finanzas/pagos-proveedores/:id" element={<PagoProveedorDetallePage />} />
                <Route path="/finanzas/bancos-presea" element={<BancosPreseaPage />} />
                <Route path="/cuentas-contables" element={<CuentasContablesPage />} />
                <Route path="/remitos" element={<RemitosPage />} />
                <Route path="/remitos/nuevo" element={<RemitoFormPage />} />
                <Route path="/logistica/remitos" element={<LogisticaRemitosPage />} />
                <Route path="/remitos/:id" element={<RemitoDetallePage />} />
                <Route path="/remitos/:id/planilla" element={<PlanillaObsequiadosPage />} />
                <Route path="/notas-envio/:id" element={<NotaEnvioDetallePage />} />
                <Route path="/asignacion" element={<AsignacionPage />} />
                <Route path="/asignaciones" element={<AsignacionPage />} />
                {/* /salidas (listado viejo) quedó duplicado con el Historial → redirige */}
                <Route path="/salidas" element={<Navigate to="/logistica/historial" replace />} />
                <Route path="/salidas/nueva" element={<SalidaFormPage />} />
                <Route path="/salidas/:id" element={<SalidaDetallePage />} />
                {/* Alias histórico: misma vista que /remitos/:id (look documento + entregas + acciones) */}
                <Route path="/logistica/remitos/:id" element={<RemitoDetallePage />} />
                <Route path="/logistica/notas-envio/:id" element={<LogisticaNeDetallePage />} />
                <Route path="/logistica/distribucion" element={<DistribucionPage />} />
                <Route path="/logistica/retiros" element={<RetirosPage />} />
                <Route path="/casos" element={<CasosPage />} />
                <Route path="/casos/:id" element={<CasoDevolucionPage />} />
                <Route path="/clientes/wine-club" element={<WineClubSociosPage />} />
                <Route path="/clientes/resenas" element={<ResenasPage />} />
                <Route path="/clientes/resenas-productos" element={<ResenasProductosPage />} />
                <Route path="/ventas/sommelier" element={<SommelierConsultasPage />} />
                <Route path="/clientes/cuentas-web" element={<CuentasWebPage />} />
                <Route path="/logistica/historial" element={<HistorialPage />} />
                <Route path="/valores" element={<ValoresPage />} />
                <Route path="/logs-actividad" element={<LogActividadPage />} />
                <Route path="/configuracion/sugerencias" element={<SugerenciasPage />} />
                <Route path="/sistema/asistente-conversaciones" element={<AsistenteConversacionesPage />} />
                <Route path="/integraciones/magento" element={<MagentoPage />} />
                <Route path="/sistema/mercadolibre" element={<MercadolibrePage />} />
                <Route path="/integraciones/presea" element={<PreseaPage />} />
                <Route path="/integraciones/presea/cola" element={<PreseaCola />} />
                {/* Resolución (motor LGR↔Presea) APAGADA — Martin, 20 oct 2026: "no se usa". El link viejo cae en la Cola. */}
                <Route path="/integraciones/presea/resolucion" element={<Navigate to="/integraciones/presea/cola" replace />} />
                <Route path="/integraciones/presea/maestros" element={<PreseaMaestros />} />
                <Route path="/configuracion/menu" element={<MenuPermisosPage />} />
                <Route path="/informes" element={<InformesPage />} />
                <Route path="/bi" element={<BiTableroPage />} />
                <Route path="/bi/ventas" element={<BiVentasPage />} />
                <Route path="/bi/gastos" element={<BiGastosPage />} />
                <Route path="/bi/cubo" element={<BiCuboPage />} />
                <Route path="/bi/cubo-ventas" element={<BiCuboVentasPage />} />
                <Route path="/bi/reportes" element={<BiReportesPage />} />
                <Route path="/bi/reportes/:clave" element={<BiReportesPage />} />
                <Route path="/proxima-seleccion" element={<MktProximaSeleccionPage />} />
                <Route path="/segunda-compra" element={<MktSegundaCompraPage />} />
                <Route path="/recompra" element={<MktRecompraPage />} />
                <Route path="/regalos-empresariales" element={<MktRegalosEmpresarialesPage />} />
                <Route path="/newsletter-experiencias" element={<MktNewsletterExperienciasPage />} />
                <Route path="/marketing/campanas" element={<MktCampanasPage />} />
                <Route path="/marketing/campanas/nueva" element={<MktCampanaFormPage />} />
                <Route path="/marketing/campanas/:id" element={<MktCampanaDetallePage />} />
                <Route path="/marketing/campanas/:id/editar" element={<MktCampanaFormPage />} />
                <Route path="/marketing/automations" element={<MktAutomationsPage />} />
                <Route path="/marketing/listas" element={<MktListasPage />} />
                <Route path="/marketing/plantillas" element={<MktPlantillasPage />} />
                <Route path="/marketing/contactos" element={<MktContactosPage />} />
                <Route path="/comunicaciones/whatsapp" element={<WhatsAppPage />} />
                <Route path="/comunicaciones/whatsapp/equipos" element={<WhatsAppConfigPage />} />
                {/* COMPRAS → Pedidos (Nota de Pedido): se ejecuta en LGR. Cinco operaciones, cada una su ítem de menú (Martin, 2 sep 2026). */}
                <Route path="/compras/pedidos" element={<Navigate to="/compras/pedidos/consultas" replace />} />
                <Route path="/compras/pedidos/ingreso" element={<NotaPedidoFormPage />} />
                <Route path="/compras/pedidos/nueva" element={<Navigate to="/compras/pedidos/ingreso" replace />} />
                <Route path="/compras/pedidos/modificacion" element={<PedidoOperacionPage key="modificacion" op="modificacion" />} />
                <Route path="/compras/pedidos/anulacion" element={<PedidoOperacionPage key="anulacion" op="anulacion" />} />
                <Route path="/compras/pedidos/cancelacion" element={<PedidoOperacionPage key="cancelacion" op="cancelacion" />} />
                <Route path="/compras/pedidos/consultas" element={<PedidosConsultaPage />} />
                <Route path="/compras/pedidos/:id" element={<NotaPedidoDetallePage />} />
                <Route path="/compras/pedidos/:id/editar" element={<NotaPedidoFormPage />} />
                <Route path="/emp900" element={<Navigate to="/emp900/facturas" replace />} />
                <Route path="/emp900/ventas" element={<Navigate to="/emp900/facturas" replace />} />
                <Route path="/emp900/facturas" element={<Emp900FacturasPage />} />
                <Route path="/emp900/recibos" element={<Emp900RecibosPage />} />
                <Route path="/emp900/remitos" element={<Emp900RemitosPage />} />
                <Route path="/emp900/compras" element={<Emp900ComprasPage />} />
                <Route path="/emp900/cuentas" element={<Emp900CuentaPage />} />
                <Route path="/emp900/stock" element={<Emp900StockPage />} />
                <Route path="/rrhh/sueadic" element={<SueAdicPage />} />
                <Route path="/rrhh/sueadic/estadisticas" element={<SueAdicEstadisticasPage />} />
                <Route path="/rrhh/agentes" element={<AgentesPage />} />
                <Route path="/rrhh/pagadores" element={<PagadoresPage />} />
                <Route path="/rrhh/bonus" element={<BonusPage />} />
                <Route path="/rrhh/bonus/:id" element={<BonusAcuerdoPage />} />
                <Route path="/procesos/entrevistas" element={<ProcesosEntrevistasPage />} />
                <Route path="/procesos/entrevistas/:id" element={<ProcesosEntrevistaDetallePage />} />
              </Routes>
            </Layout>
          </PrivateRoute>
        }
      />
    </Routes>
    </ErrorBoundary>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}
